exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-stack[data-v-a6fe6d9e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;padding:var(--v-stack-padY) var(--v-stack-padX)}.v-stack>*[data-v-a6fe6d9e]{margin-top:0;margin-bottom:0}.v-stack>*+*[data-v-a6fe6d9e]{margin-top:var(--v-stack-gap)}", ""]);

// exports
